var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"CHANNEL_UP","name":"CHANNEL_UP","data-vcode":"CHANNEL_UP"}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icn-channel-up.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('channelUp')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }